import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import SidebarContext from './SidebarContext';

const Menu = ({ children }) => {
  const { open, openCallback } = useContext(SidebarContext);
  const classes = useMemo(() => cns(
    'sidebar__menu',
    {
      'sidebar__menu--open': open,
      'sidebar__menu--closed': !open,
    },
  ), [open]);

  return (
    <div className={classes}>
      <div className="sidebar__menu__header">
        <div
          className="sidebar__menu__hamburger"
          onClick={openCallback}
          role="presentation"
        >
          <div className="sidebar__menu__hamburger__box">
            <div className="sidebar__menu__hamburger__inner" />
          </div>
        </div>
      </div>
      {children}
    </div>
  );
};

Menu.propTypes = {
  /** Contenuto da renderizzare all'interno del componente */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

Menu.defaultProps = {
  children: null,
};

export default Menu;
